import Translatable from '../translatable_text/Translatable';
import chart_img from '/light/assets/imgs/chart_img.jpg';


function MarketValue() {
  return (
    <section
      className="about-crev section-padding sub-bg position-re ontop"
      data-scroll-index="4"
    >
      <div className="container mx-auto px-4">
        <div className="flex flex-col lg:flex-row flex-wrapx gap-10 lg-marg">
          <div className="w-full lg:w-6/12x flex items-center justify-center lg:justify-start">
            <div className="left-block mt-100 md-mb50">
              <div className="flex items-center">
                <div>
                  <div className="info">
                    <p className="nowrap ">
                      <Translatable>
                        Market Values
                      </Translatable>
                    </p>
                  </div>
                </div>
                <div className=' d-rotate wow'>
                  <div 
                  className="w-[200px] h-[300px] md:w-[300px] md:h-[500px] imgx fit-img radius-30 rotate-text">
                    <img 
                      src={chart_img}
                      alt="im" 
                      width="100%" height="100%" loading='lazy'
                    />
                  </div>
                </div>
              </div>
              <div className="mz-shap">
                <svg
                  height="100%"
                  viewBox="0 0 610 547"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M116.134 529.548C116.134 538.642 123.506 546.015 132.6 546.015H211.63C211.635 546.015 211.638 546.011 211.638 546.007V546.007C211.638 546.003 211.642 545.999 211.646 545.999H592.691C601.786 545.999 609.158 538.627 609.158 529.533L609.157 251.366C609.157 242.272 601.785 234.899 592.691 234.899H401.097C392.003 234.899 384.631 227.527 384.631 218.433V112.465C384.631 103.371 377.259 95.999 368.164 95.999H214.466C205.372 95.999 198 88.6268 198 79.5327V16.4662C198 7.37219 190.628 0 181.534 0H88.4662C79.3722 0 72 7.37219 72 16.4662V104.534C72 113.628 79.3722 121 88.4662 121H166.917C176.011 121 183.383 128.372 183.383 137.466V273.565C183.383 282.659 176.011 290.031 166.917 290.031H116.134H116.134H16.5634C7.46936 290.031 0.0971666 297.403 0.0971666 306.497V445.923C0.0971666 455.017 7.46935 462.39 16.5634 462.39H99.6677C108.762 462.39 116.134 469.762 116.134 478.856V529.548Z"
                    fill="#1a1a1a"
                  ></path>
                </svg>
              </div>
            </div>
          </div>
          <div className="w-full lg:w-6/12x valign">
            <div className="content full-width">
              <div className="sec-head mb-30 wow d-rotate">
                <h2 className="sub-title mb-15 main-color">
                  <Translatable>Assets value</Translatable>  
                </h2>
                <h2 className='text-4xl rotate-text'>
                  <Translatable>Our assets market value</Translatable>  
                </h2>
              </div>
              <div className="flex justify-end">
                <div className="w-full lg:w-11/12">
                  <div className="text">
                    <span style={{ fontSize: '20px', lineHeight: '1.8', fontWeight: '200' }} className='opacity-6'>
                      <Translatable>
                        We dedicated our talents with a clear mission: to turn innovation into tangible value — reflecting our commitment, hard work, and drive to maximize returns for our investors
                      </Translatable>
                    </span>
                  </div>
                  <div className="mt-50">
                    <div className="skills-box">
                      <div className="skill-item mb-20">
                        <span className="sub-title mb-20">
                          <Translatable>Dall In Platform</Translatable>
                        </span>
                        <div className="skill-progress">
                          <div className="progres" data-value="100%"></div>
                          <div className="progres" market-value="25,600,000 SAR"/>
                        </div>
                      </div>

                      <div className="skill-item mb-20">
                        <span className="sub-title mb-15">
                          <Translatable>IGI App</Translatable>
                        </span>
                        <div className="skill-progress">
                          <div className="progres" data-value="90%"></div>
                          <div className="progres" market-value="10,800,000 SAR"/>
                        </div>
                      </div>

                      <div className="skill-item mb-20">
                        <span className="sub-title mb-15">
                          <Translatable>ACC App</Translatable>
                        </span>
                        <div className="skill-progress">
                          <div className="progres" data-value="80%"></div>
                          <div className="progres" market-value="3,600,000 SAR"/>
                        </div>
                      </div>

                      <div className="skill-item mb-20">
                        <span className="sub-title mb-15">
                          <Translatable>SDC App</Translatable>
                        </span>
                        <div className="skill-progress">
                          <div className="progres" data-value="70%"></div>
                          <div className="progres" market-value="2,000,000 SAR"/>
                        </div>
                      </div>

                      <div className="skill-item mb-20">
                        <span className="sub-title mb-15">
                          <Translatable>Letarafo App</Translatable>
                        </span>
                        <div className="skill-progress">
                          <div className="progres" data-value="70%"></div>
                          <div className="progres" market-value="3,000,000 SAR"/>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="text">
                    <br />
                    <span style={{ fontSize: '20px', lineHeight: '1.8', fontWeight: '200' }} className='opacity-6'>
                      <Translatable>Total Market Value is</Translatable>  {" "}
                      <span>45,000,000 SAR</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default MarketValue;
